import { Box, Typography } from '@mui/material'
import type { DateTime } from 'luxon'
import { useTranslation } from 'react-i18next'

type MarketGateClosedProps = {
  marketLabel: string
  deliveryDay: DateTime
}

function MarketGateClosed({ marketLabel, deliveryDay }: Readonly<MarketGateClosedProps>) {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        p: 4,
      }}
    >
      <Typography color="text.secondary" variant="h6">
        {t('bidding.bidding_cascading.market_gate_closed', {
          market: marketLabel,
          deliveryDay: deliveryDay.toLocaleString({ dateStyle: 'long' }),
        })}
      </Typography>
    </Box>
  )
}

export default MarketGateClosed
